module.exports = __webpack_public_path__ + "static/img/10.cb0ece6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/10.png
// module id = GAwJ
// module chunks = 0